// Generated by purs version 0.14.1
"use strict";
var otherwise = true;
module.exports = {
    otherwise: otherwise
};
